import { createRef, PureComponent, createElement } from "react";
import scrollIntoViewIfNeeded from "scroll-into-view-if-needed";
import PropTypes from "prop-types";

class ScrollIntoViewIfNeeded extends PureComponent {
  //   static propTypes = {
  //     active: PropTypes.bool,
  //     children: PropTypes.node.isRequired,
  //     elementType: PropTypes.string,
  //     // this shape should mirror the scroll-into-view-if-needed options
  //     options: PropTypes.shape({
  //       behavior: PropTypes.oneOfType([
  //         PropTypes.oneOf(["auto", "smooth", "instant"]),
  //         PropTypes.func
  //       ]),
  //       block: PropTypes.oneOf(["center", "end", "nearest", "start"]),
  //       inline: PropTypes.oneOf(["center", "end", "nearest", "start"]),
  //       scrollMode: PropTypes.oneOf(["always", "if-needed"]),
  //       boundary: PropTypes.oneOfType([
  //         // eslint-disable-next-line no-undef
  //         PropTypes.instanceOf(Element),
  //         PropTypes.func
  //       ]),
  //       skipOverflowHiddenElements: PropTypes.bool
  //     })
  //   };

  static defaultProps = {
    active: true,
    elementType: "div",
    options: {
      // behavior: "smooth",
      behavior: "instant",
      block: "start",
      inline: "center",
      scrollMode: "if-needed"
    }
  };

  constructor(props) {
    super(props);
    this.nodeRef = createRef();
  }

  componentDidMount() {
    const { active } = this.props;

    if (active) {
      this.handleScrollIntoViewIfNeeded();
    }
  }

  componentDidUpdate(prevProps) {
    const { active } = this.props;

    if (!prevProps.active && active) {
      this.handleScrollIntoViewIfNeeded();
    }
  }

  handleScrollIntoViewIfNeeded = () => {
    const { options } = this.props;
    scrollIntoViewIfNeeded(this.nodeRef.current, options);
  };

  render() {
    const {
      active,
      elementType,
      children,
      options,
      ...wrapperProps
    } = this.props;

    return createElement(
      elementType,
      { ref: this.nodeRef, ...wrapperProps },
      children
    );
  }
}

ScrollIntoViewIfNeeded.propTypes = {
  active: PropTypes.bool,
  elementType: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  options: PropTypes.object
};

export default ScrollIntoViewIfNeeded;
